
export default () => (
  <svg width="44" height="45" viewBox="0 0 44 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M-7.28523e-07 23.3333C-7.68758e-07 22.4129 0.757671 21.6667 1.69231 21.6667L37.3759 21.6667L25.0341 9.51185C24.3732 8.86097 24.3732 7.8057 25.0341 7.15483C25.695 6.50395 26.7665 6.50395 27.4274 7.15483L42.6582 22.1548C43.3191 22.8057 43.3191 23.861 42.6582 24.5118L27.4274 39.5118C26.7665 40.1627 25.695 40.1627 25.0341 39.5118C24.3732 38.861 24.3732 37.8057 25.0341 37.1548L37.3759 25L1.69231 25C0.757671 25 -6.88288e-07 24.2538 -7.28523e-07 23.3333Z" fill="white"/>
  </svg>

)
